import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getActivity } from './api';
import { ActivityDTO } from './dto/ActivityDTO';
import { QueryKey } from '../QueryKey';
import { goToErrorPage } from 'utils';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<ActivityDTO>, 'onSuccess'>;

export default function useActivity(activityId: number, options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();

  const { data: activity, isFetching } = useQuery<ActivityDTO>(
    [QueryKey.ACTIVITY, activityId],
    () => getActivity(activityId),
    {
      onError: (error: any) => {
        goToErrorPage(error);
        toast.error(t('message.title.error.get.activity') + error.message);
      },
      retry: false,
      onSuccess: data => {},
      ...options,
    }
  );

  return { activity: activity, getActivity, isFetching };
}
